<script lang="ts">
	//Components

	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	import VGroupComponentsV2 from 'src/components/DevicesSettings/VirtualComponents/ComponentsV2/VGroupComponentsV2.svelte';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content" class="flex-full-height justify-content-start">
		<VGroupComponentsV2 {device} />
	</div>
</DeviceViewStateWrapper>
